import { Chip } from "@mui/material";
import { C } from "@plannel/components/ai/aiTokens";
import { FONT } from "@plannel/components/ai/typographyTokens";

// 제공사 칩 — 표시명이 겹칠 때만 붙여 어느 제공사의 모델인지 구분한다(값은 코드 그대로: bedrock 등)
const ProviderChip = ({ provider }) => (
  <Chip size="small" variant="outlined" label={provider}
    sx={{ height: 18, flexShrink: 0, fontSize: FONT.CAPTION, color: C.text2, borderColor: C.border,
      "& .MuiChip-label": { px: 0.75 } }} />
);

export default ProviderChip;
